<template>
  <div class="reset-password">
    <div class="reset-password-form">
      <loading-logo ref="loadingLogo"/>
      <form v-if="isTokenValid">
        <vi-input
          :autofocus="true"
          v-model="resetPasswordForm.password"
          label="Password"
          type="password"
          :disabled="isLoading"
          placeholder=""
          @input="onInput"
        />
        <vi-input
          v-model="resetPasswordForm.repeatPassword"
          label="Repeat Password"
          type="password"
          :disabled="isLoading"
          placeholder=""
          @input="onInput"
        />
        <div v-if="resetPasswordErr" class="error">
          {{ resetPasswordErr }}
        </div>
        <div class="actions">
          <vi-recaptcha-button
            label="RESET"
            :disabled="isLoading"
            @verify="resetPassword"
            />
        </div>
      </form>
      <div v-if="!isTokenValid">
        <h4>Token invalid</h4>
      </div>
    </div>
  </div>
</template>

<script>
  import ViInput from "../components/ui/ViInput";
  import ViButton from "../components/ui/ViButton";
  import lottie from 'lottie-web';
  import {required} from 'vuelidate/lib/validators'
  import LoadingLogo from "../components/LoadingLogo";
  import ViRecaptchaButton from "../components/ui/ViRecaptchaButton";

  export default {
    name: "ResetPassword",
    components: {ViRecaptchaButton, LoadingLogo, ViButton, ViInput},
    props: {
      token: {
        type: String
      }
    },

    data() {
      return {
        resetPasswordForm: {
          password: '',
          repeatPassword: ''
        },
        resetPasswordErr: '',
        isLoading: false,
        isTokenValid: false,
      }
    },

    validations: {
      resetPasswordForm: {
        password: {
          required
        },
        repeatPassword: {
          required
        }
      }
    },

    methods: {
      onInput() {
        this.resetPasswordErr = null
      },
      resetPassword(gRecaptcha) {

        this.$v.$touch();
        if (this.$v.$error) {
          return;
        }

        this.setIsLoading(true);

        this.$store
          .dispatch('resetPassword/resetPassword',
            {...this.resetPasswordForm, token: this.token, gRecaptcha})
          .then(() => {
            this.resetPasswordForm = {
              password: '',
              repeatPassword: ''
            };
            this.setIsLoading(false);
            this.$router.push({
              name: "Login"
            })
          })
          .catch(() => {
            this.setIsLoading(false);
            this.resetPasswordErr = "Passwords dont match";
          })
      },
      setIsLoading(isLoading) {
        this.isLoading = isLoading;
        this.$refs.loadingLogo.setLoading(isLoading);
      }
    },

    created() {
      this.$store
        .dispatch('resetPassword/validateResetPasswordToken', this.token)
        .then(() => {
          this.isTokenValid = true;
        })
        .catch(err => {
          this.isTokenValid = false;
        })

      //  window.resetPassword = this.resetPassword;

    },
  }
</script>

<style lang="scss">
  @import "ResetPassword";
</style>
